import urls from './urls.json';

const visitsUrlFromEnv = window.VISIT_URL;

export default visitsUrlFromEnv || urls.visitsUrl;
